import { stripIndent } from 'common-tags';
import { SubscriptionCanceled } from './components/SubscriptionCanceled';

export const subscriptionCanceledEmailTemplate = {
  label: 'Subscription Canceled',
  description: 'Sent when a customer\'s subscription is canceled',
  icon: 'CloseCircleLine',
  component: SubscriptionCanceled,
  defaultTemplate: {
    name: 'Subscription Canceled',
    subject: {
      en: 'Your subscription to {{ subscriptionName }} has been canceled',
      fr: 'Votre abonnement à {{ subscriptionName }} a été annulé',
      it: 'Il tuo abbonamento a {{ subscriptionName }} è stato annullato',
      es: 'Tu suscripción a {{ subscriptionName }} ha sido cancelada',
      de: 'Dein Abonnement für {{ subscriptionName }} wurde gekündigt',
    },
    templateVariables: {
      subscription_canceled: {
        body: {
          en: stripIndent`
            <p>Hi {{ customerFirstName }},</p>
            <p>Your subscription to <strong>{{ subscriptionName }}</strong> has been canceled.</p>
            <p>If this was a mistake or you'd like to resubscribe, you can do so at any time from your account.</p>
            <p>We hope to see you again soon!</p>
          `,
          fr: stripIndent`
            <p>Bonjour {{ customerFirstName }},</p>
            <p>Votre abonnement à <strong>{{ subscriptionName }}</strong> a été annulé.</p>
            <p>Si c'est une erreur ou si vous souhaitez vous réabonner, vous pouvez le faire à tout moment depuis votre compte.</p>
            <p>Nous espérons vous revoir bientôt !</p>
          `,
          it: stripIndent`
            <p>Ciao {{ customerFirstName }},</p>
            <p>Il tuo abbonamento a <strong>{{ subscriptionName }}</strong> è stato annullato.</p>
            <p>Se è stato un errore o desideri riabbonarti, puoi farlo in qualsiasi momento dal tuo account.</p>
            <p>Speriamo di rivederti presto!</p>
          `,
          es: stripIndent`
            <p>Hola {{ customerFirstName }},</p>
            <p>Tu suscripción a <strong>{{ subscriptionName }}</strong> ha sido cancelada.</p>
            <p>Si fue un error o deseas volver a suscribirte, puedes hacerlo en cualquier momento desde tu cuenta.</p>
            <p>¡Esperamos verte de nuevo pronto!</p>
          `,
          de: stripIndent`
            <p>Hallo {{ customerFirstName }},</p>
            <p>Dein Abonnement für <strong>{{ subscriptionName }}</strong> wurde gekündigt.</p>
            <p>Falls dies ein Versehen war oder du dich erneut anmelden möchtest, kannst du dies jederzeit über dein Konto tun.</p>
            <p>Wir hoffen, dich bald wiederzusehen!</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
    { key: 'subscriptionAmount', label: 'Subscription Amount', example: '$19.99' },
  ],
  utmParameters: {
    utmSource: 'subscription_canceled',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
      priceSnapshot: { currencyOptions: { USD: { amount: 1999 } } },
    },
  }),
  defaultMessages: {
    promotion_title: 'Your Special Offer',
    promotion_subtitle: 'Use this code for your next purchase',
    cta_button: 'Resubscribe',
    footer_text: '© 2025 All rights reserved',
  },
};
